var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-base page-full-height"},[(_vm.$screen.mdDown)?_c('PxTabBar'):_c('PxNavbar',{attrs:{"theme":"centered"}}),_c('RouterView',{staticClass:"page-body"}),_c('PxFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }